<template>
  <div>
    <div class="text-center my-10">
      <h1 class="page-title text-primary">Kontakt</h1>
      <p class="page-subtitle">Wir freuen uns auf Ihre Nachricht</p>
    </div>

    <v-row>
      <v-col cols="12" sm="5">
        <v-card class="bg-surface pa-6 card-clean h-100" elevation="1">
          <v-img
            :lazy-src="require(`./../assets/images/Logo_ausgeschnitten.png`)"
            transition="true"
            alt="Logo Schreinerei M²"
            class="mb-4"
            max-height="120"
            contain
            :src="require(`./../assets/images/Logo_ausgeschnitten.png`)"
          ></v-img>
          <h2 class="contact-name mb-1">Schreinerei M²</h2>
          <p class="body-text mb-1">Matthias Joas & Mika Herrmann</p>
          <div class="mt-4">
            <div class="contact-row">
              <v-icon size="18" class="mr-2" color="accent">mdi-map-marker</v-icon>
              <span class="body-text">Schlayerstraße 6, 72793 Pfullingen</span>
            </div>
            <div class="contact-row">
              <v-icon size="18" class="mr-2" color="accent">mdi-email</v-icon>
              <a href="mailto:info@schreinereim2.de" class="body-text contact-link">info@schreinereim2.de</a>
            </div>
            <div class="contact-row">
              <v-icon size="18" class="mr-2" color="accent">mdi-phone</v-icon>
              <a href="tel:+4915778204841" class="body-text contact-link">+49 1577 8204841</a>
            </div>
          </div>
          <v-btn
            size="large"
            block
            class="bg-accent text-primary mt-6"
            href="tel:+4915778204841"
          >
            <v-icon start>mdi-phone</v-icon>
            Jetzt anrufen
          </v-btn>
        </v-card>
      </v-col>

      <v-col cols="12" sm="7">
        <v-card class="bg-surface pa-6 card-clean h-100" elevation="1">
          <h3 class="form-title mb-4">Schreiben Sie uns</h3>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            :action="`mailto:info@schreinereim2.de?subject=${subject}&body=${message}`"
            method="POST"
            enctype="text/plain"
            @submit="sendEmail"
          >
            <v-text-field
              v-model="subject"
              label="Betreff"
              required
              variant="outlined"
              color="accent"
              class="mb-2"
            ></v-text-field>
            <v-textarea
              v-model="message"
              label="Ihre Nachricht"
              required
              variant="outlined"
              color="accent"
              rows="6"
            ></v-textarea>
            <v-btn
              :disabled="!valid"
              block
              size="large"
              class="bg-primary text-accent mt-2"
              type="submit"
            >
              <v-icon start>mdi-email-send</v-icon>
              Nachricht senden
            </v-btn>
          </v-form>
        </v-card>
      </v-col>
    </v-row>

    <div class="mb-8"></div>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: true,
    subject: "",
    message: "",
  }),
  methods: {
    sendEmail(event) {
      console.log(event);
    },
  },
};
</script>

<style scoped>
.page-title {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: clamp(1.5em, 5vw, 2.5em);
  font-weight: 400;
}

.page-subtitle {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 1em;
  opacity: 0.6;
  margin-top: 0.5rem;
}

.card-clean {
  border-radius: 12px;
}

.contact-name {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-weight: 600;
  font-size: 1.2em;
}

.body-text {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-size: 0.95em;
  line-height: 1.7;
}

.form-title {
  font-family: "ManropeLight", Arial, Helvetica, sans-serif;
  font-weight: 400;
  font-size: 1.2em;
}

.contact-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.contact-link {
  color: inherit;
  text-decoration: none;
}

.contact-link:hover {
  text-decoration: underline;
}
</style>
